import { createStore } from 'vuex'
import HomeModule from '@/store/modules/HomeModule'

export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    HomeModule
  }
})
